import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { APPEAR_ANIMATION_DURATION } from '@modules/paint-picker-new/config';

const DETAIL_IMAGE_REVEAL_TRANSITION_ICONS =
    'opacity 350ms ease-in 0s, visibility 350ms ease-in 0s';

export const HoverButtonsImageContainer: StyleRule = ({ theme }) => ({
    position: 'absolute',
    right: pxToRem(12),
    top: pxToRem(12),
    zIndex: theme.siteVariables.zIndexes.foreground,
    transition: DETAIL_IMAGE_REVEAL_TRANSITION_ICONS,
    opacity: 1,
    visibility: 'visible',

    [theme.screen.laptop]: {
        right: pxToRem(16),
        top: pxToRem(16),
        opacity: 0,
        visibility: 'hidden',
    },

    '& > *': {
        lineHeight: 0.9,
        marginLeft: pxToRem(8),
        '&:not(:first-of-type)': {
            marginLeft: pxToRem(8),
        },
    },
});

export const HoverButtonsHintContainer: StyleRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    background: '#e5e5e5',
    borderRadius: '20px',
    gap: pxToRem(5),
    padding: `0 0 0 ${pxToRem(15)}`,
});

export const HoverButtonsHintLabel: StyleRule = () => ({
    margin: `${pxToRem(1)} 0 0 0`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});

export const FavouriteButton: StyleRule = ({ theme }) => ({
    pointerEvents: 'auto',
    overflow: 'hidden',

    [`& .${svgIconClassName} svg`]: {
        fill: theme.siteVariables.colors.charcoal[250],
    },
    backgroundColor: theme.siteVariables.colors.white[300],
    ':first-child:hover': {
        backgroundColor: theme.siteVariables.colors.white[250],
    },
});

export const hintAnimation = {
    hintOn: {
        gap: pxToRem(5),
        padding: `0 0 0 ${pxToRem(15)}`,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    hintOff: {
        gap: 0,
        padding: 0,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
};

export const hintLabelAnimation = {
    hintOn: {
        opacity: 1,
        width: 'fit-content',
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    hintOff: {
        opacity: 0,
        width: [null, '0px'],
        transition: { duration: APPEAR_ANIMATION_DURATION },
        transitionEnd: { display: 'none' },
    },
};
